import React from "react"
import "./Box.scss"

export default ({ children }) => {
  return <div className="box">{children}</div>
}
